import React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    withStyles
} from "@material-ui/core";
import { formatDate } from '../../sc-utilities';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const ExtendSessionModal = (props) => {
    const { classes, translations, extendSessionModal, setExtendSessionModal, clientType, extendSessionModalCloseDanger} = props;

    const user = extendSessionModal?.rowData?.User;

    const handleCloseSafe = () => {
        setExtendSessionModal({open: false, rowData: null});
    }

    const contentText = `
        ${translations['extend_session_for'] || "Do you want to extend session for"} ${user?.Username} ${translations['on'] || "on"}
        ${clientType} ${translations['client'].toLowerCase() || "client"}?
    `;

    return (
        <Dialog
            open={extendSessionModal.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="extend-session-dialog-title">{translations['extend_session'] || 'Extend session'}</DialogTitle>
            {user && <DialogContent>
                <DialogContentText>
                    {contentText}<br/>
                    {` (${translations['session_expires_at'] || "Session expires at"}: ${formatDate(extendSessionModal?.rowData?.ExpiresAt)})`}
                </DialogContentText>
            </DialogContent>}
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={extendSessionModalCloseDanger} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(ExtendSessionModal);